<template>
  <table id="draggabletable" class="table table-striped table-bordered">
    <thead>
      <tr>
        <th
          v-for="(item, key, index) in columnTitles"
          :key="index"
          :toggle="currentToggle"
          @click="toggleSort"
          class="flat"
          style="word-break: keep-all; padding-right: 20px"
        >
          {{ item }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(list, key, index) in displayItems" :key="index">
        <td v-for="(value, key2, index2) in list" :key="index2">
          <!-- 列にボタンが1つの場合 -->
          <template v-if="identifyContentsOfTheColumn(value) === 'button'">
            <actionButton
              :id="value.id"
              :type="value.type"
              :disabled="forRecommends && (!shopsReady || !itemsReady)"
              @buttonClickEvent="buttonClickEvent"
            />
          </template>
          <!-- 列にボタンが複数ある場合 -->
          <template
            v-else-if="identifyContentsOfTheColumn(value) === 'buttons'"
          >
            <actionButton
              v-for="(button, key3, index3) in value"
              :id="button.id"
              :key="index3"
              :type="button.type"
              @buttonClickEvent="buttonClickEvent"
            />
          </template>
          <!-- 列の内容がチェックボックスの場合 -->
          <template
            v-else-if="identifyContentsOfTheColumn(value) === 'checkbox'"
          >
            <selectCheckBox
              :id="value.id"
              :checked="value.checked"
              :target="value.target || null"
              @checkBoxEvent="checkBoxEvent"
            />
          </template>
          <!-- 列の内容がセレクターの場合 -->
          <template v-else-if="identifyContentsOfTheColumn(value) === 'select'">
            <selectlist
              :id="value.id"
              :selected="value.selected"
              :options-list="value.options"
              :target="value.target || null"
              @selectEvent="selectEvent"
            />
          </template>
          <!-- 列の内容がテキストの場合 -->
          <template v-else-if="identifyContentsOfTheColumn(value) === 'input'">
            <inputForm
              :id="value.id"
              :input-mode="value.mode"
              :input-value="value.inputValue"
              :target="value.target || null"
              @inputEvent="inputEvent"
            />
          </template>
          <!-- 列の内容がラジオボタンの場合 -->
          <template v-else-if="identifyContentsOfTheColumn(value) === 'radio'">
            <radio-button
              :id="value.id"
              :name="value.name"
              :value="value.value"
              :checked="value.checked"
              @RadioButtonEvent="RadioButtonEvent"
            />
          </template>
          <!-- 列の内容がアコーディオン表示の場合 -->
          <template
            v-else-if="identifyContentsOfTheColumn(value) === 'accordion'"
          >
            <accordion :id="value.id" :title="value.title" :body="value.body" />
          </template>
          <!-- 列の内容が文字列の場合 -->
          <template v-else>
            <span v-html="value"></span>
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<style scoped>
thead th {
  cursor: pointer;
  position: relative;
}
thead th::after {
  content: '';
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: block;
  width: 10px;
  height: 10px;
  opacity: 0.5;
}
.asc::after {
  border-top: 2px solid #666;
  border-left: 2px solid #666;
  transform: rotate(45deg);
  top: 14px;
}
.desc::after {
  border-right: 2px solid #666;
  border-bottom: 2px solid #666;
  transform: rotate(45deg);
  top: 10px;
}
.flat::after {
  border-top: 2px solid #666;
}

td span {
  line-height: unset;
}
</style>

<script>
import Button from '@/components/common/table/button'
import CheckBox from '@/components/common/table/CheckBox'
import Select from '@/components/common/table/Select'
import InputForm from '@/components/common/table/InputForm'
import RadioButton from '@/components/common/table/RadioButton'
import Accordion from '@/components/common/table/Accordion'
import _ from 'lodash'
export default {
  components: {
    actionButton: Button,
    selectCheckBox: CheckBox,
    selectlist: Select,
    inputForm: InputForm,
    RadioButton: RadioButton,
    Accordion,
  },
  props: [
    'columnTitles',
    'displayItems',
    'forRecommends',
    'itemsReady',
    'shopsReady',
  ],
  data() {
    return {
      currentToggle: 0,
    }
  },
  methods: {
    identifyContentsOfTheColumn: function(column) {
      if (Array.isArray(column)) {
        // ボタンが複数あるカラムを想定
        return 'buttons'
      } else if (column === null) {
        return null
      } else if (typeof column === 'object') {
        // チェックボックを想定
        if (column.type === 'checkbox') {
          return 'checkbox'
        }
        // セレクターを想定
        if (column.type === 'select') {
          return 'select'
        }
        // インプットを想定
        if (column.type === 'input') {
          return 'input'
        }
        // ラジオボタンを想定
        if (column.type === 'radio') {
          return 'radio'
        }
        // アコーディオンを想定
        if (column.type === 'accordion') {
          return 'accordion'
        }
        // 単一のボタンしかないカラムを想定
        return 'button'
      } else {
        // 値をそのまま返す
        return 'string'
      }
    },
    buttonClickEvent: function(type, id) {
      this.$emit('buttonClickEvent', type, id)
    },
    checkBoxEvent: function(bool, id, target) {
      this.$emit('checkBoxEvent', bool, id, target)
    },
    selectEvent: function(selectValue, id, target) {
      this.$emit('selectEvent', selectValue, id, target)
    },
    inputEvent: function(value, id, target) {
      this.$emit('inputEvent', value, id, target)
    },
    RadioButtonEvent: function(value, id, name) {
      this.$emit('RadioButtonEvent', value, id, name)
    },
    toggleSort: function(event) {
      let cell = event.target
      let order = 'desc'
      if (cell.className === 'asc') {
        cell.className = 'desc'
        order = 'desc'
      } else if (cell.className === 'desc') {
        cell.className = 'asc'
        order = 'asc'
      } else {
        cell.className = 'desc'
        order = 'desc'
      }
      const cellIndex = event.target.cellIndex
      const sort = _.orderBy(
        this.displayItems,
        (item) => {
          if (typeof item[cellIndex] === 'object') {
            if (item[cellIndex].type === 'select') {
              return item[cellIndex].selected
            }
            if (item[cellIndex].type === 'checkbox') {
              return item[cellIndex].checked
            }
            if (item[cellIndex].type === 'accordion') {
              return item[cellIndex].title
            }
            return item[cellIndex].inputValue
          } else {
            return item[cellIndex]
          }
        },
        order
      )
      this.$emit('sortTable', sort)
    },
  },
}
</script>
